export const getCroppedImg = async (imageSrc, pixelCrop, rotation = 0) => {
  // Helper to create an image from a URL
  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous"); // needed for cross-origin images
      image.onload = () => resolve(image);
      image.onerror = (error) => reject(error);
      image.src = url;
    });

  const image = await createImage(imageSrc);

  // Calculate the safe area size (to accommodate rotated image without clipping)
  const maxSize = Math.max(image.width, image.height);
  const safeArea = maxSize * Math.sqrt(2);

  // Create a canvas with the safe area dimensions
  const safeCanvas = document.createElement("canvas");
  safeCanvas.width = safeArea;
  safeCanvas.height = safeArea;
  const safeCtx = safeCanvas.getContext("2d");

  // Translate and rotate the canvas context
  safeCtx.translate(safeArea / 2, safeArea / 2);
  safeCtx.rotate((rotation * Math.PI) / 180);
  safeCtx.translate(-image.width / 2, -image.height / 2);

  // Draw the original image in the center of the safe canvas
  safeCtx.drawImage(image, 0, 0);

  // Calculate the offset (the safe canvas has the image centered)
  const dx = (safeArea - image.width) / 2;
  const dy = (safeArea - image.height) / 2;

  // Determine the crop area on the safe canvas
  const cropX = pixelCrop.x + dx;
  const cropY = pixelCrop.y + dy;
  const cropWidth = pixelCrop.width;
  const cropHeight = pixelCrop.height;

  // Create a canvas to hold the rectangular cropped image
  const outputCanvas = document.createElement("canvas");
  outputCanvas.width = cropWidth;
  outputCanvas.height = cropHeight;
  const outputCtx = outputCanvas.getContext("2d");

  // Draw the rectangular crop area from the safe canvas into the output canvas
  outputCtx.drawImage(
    safeCanvas,
    cropX,
    cropY,
    cropWidth,
    cropHeight,
    0,
    0,
    cropWidth,
    cropHeight
  );

  // Now create another canvas for the final circular crop
  const circularCanvas = document.createElement("canvas");
  circularCanvas.width = cropWidth;
  circularCanvas.height = cropHeight;
  const circularCtx = circularCanvas.getContext("2d");

  // Create a circular clipping path
  circularCtx.beginPath();
  circularCtx.arc(cropWidth / 2, cropHeight / 2, cropWidth / 2, 0, 2 * Math.PI);
  circularCtx.closePath();
  circularCtx.clip();

  // Draw the rectangular cropped image onto the circular canvas
  circularCtx.drawImage(outputCanvas, 0, 0);

  // Export the circular cropped image as a PNG (with transparency outside the circle)
  return circularCanvas.toDataURL("image/png");
};
